import { GenericBackendResponse } from '../genericBackendResponse';
import { PensionPlanRegistryItem, PlanType } from './getArcaPlansFinancials';

interface RegistryList {
	items: PensionPlanRegistryItem[];
}

/** Con la sesión del usuario, nunca con `x-password` (ver `getCatalogPlanBySlug`). */
export async function getOriginPlanType(
	dgsfpCode: string,
	token: string
): Promise<PlanType | null> {
	if (!token || !dgsfpCode) return null;

	try {
		const response = await fetch(
			`${process.env.REACT_APP_BASE_API}/pension-plan-registry/search?q=${encodeURIComponent(dgsfpCode)}&page=1&limit=1`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`
				}
			}
		);
		if (!response.ok) return null;
		const json: GenericBackendResponse<RegistryList> = await response.json();
		return json.data?.items?.[0]?.planType ?? null;
	} catch {
		return null;
	}
}
